import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { MagicFillFieldButton } from "./MagicFillFieldButton";
import { MagicFillFormType, MagicFillMetadata } from "./MagicFillButton";
import { cn } from "@/infrastructure/lib/utils";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectWithMagicFillProps {
  formType: MagicFillFormType;
  fieldKey: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCurrentValues: () => Record<string, any>;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMagicFillApply: (value: any) => void;
  onLoadingChange?: (isLoading: boolean) => void;
  metadata?: MagicFillMetadata;
  showMagicFill?: boolean;
  value?: string;
  onValueChange?: (value: string) => void;
  options: SelectOption[] | string[];
  placeholder?: string;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  error?: boolean;
  id?: string;
}

export const SelectWithMagicFill = ({
  formType,
  fieldKey,
  getCurrentValues,
  onMagicFillApply,
  onLoadingChange,
  metadata,
  showMagicFill = true,
  value,
  onValueChange,
  options,
  placeholder = "Selecione uma opção",
  disabled = false,
  isLoading = false,
  className,
  error,
  id,
}: SelectWithMagicFillProps) => {
  const isDisabled = disabled || isLoading;
  const normalizedOptions: SelectOption[] = options.map((opt) => {
    if (typeof opt === "string") {
      return { value: opt, label: opt };
    }
    return opt;
  });

  return (
    <div className="relative">
      <Select value={value} onValueChange={onValueChange} disabled={isDisabled}>
        <SelectTrigger
          id={id}
          className={cn("pr-10", className)}
          error={error}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {normalizedOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showMagicFill && !isDisabled && (
        <MagicFillFieldButton
          formType={formType}
          fieldKey={fieldKey}
          getCurrentValues={getCurrentValues}
          metadata={{
            ...metadata,
            fieldOptions: normalizedOptions.map((opt) => opt.value),
          }}
          onApplySuggestion={onMagicFillApply}
          onLoadingChange={onLoadingChange}
        />
      )}
    </div>
  );
};

SelectWithMagicFill.displayName = "SelectWithMagicFill";
